// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isSdkAuthChangelogResult = objectOf({
  changelog_items: arrayOf(
    objectOf({
      date: number,
      email: string,
      diffs: arrayOf(
        objectOf({
          field_name: string,
          before: nullOrUndefined,
          after: number,
          tag: string,
          // key: objectOf({
          //   id: string,
          //   rpk: string,
          //   cat: number,
          //   kd: string,
          // }),
        })
      ),
    })
  ),
});
